/** 菜单选项 */
export enum EBuycarType {
  /** 下订/分享 */
  ORDER = "1",
  /** 询价 */
  INQUIRY = "2",
}

/** 菜单排序类型 */
export enum ESortType {
  /** 浏览数 - 高到低 */
  VIEWS_DESC = "view-desc",
  /** 浏览数 - 低到高 */
  VIEWS_ASC = "view-asc",
  /** 成交 - 新到旧 */
  DATE_DESC = "date-desc",
  /** 成交 - 旧到新 */
  DATE_ASC = "date-asc",
  /** 互动性 - 高到低 */
  INTERACTIVE_DESC = "interactive-desc",
  /** 互动性 - 低到高 */
  INTERACTIVE_ASC = "interactive-asc",
}
/** 获取数据量 */
export enum ECountType {
  /** 总共 */
  TOTAL = "1",
  /** 全部数据 */
  ALL = "0",
}

/** 是或否 */
export enum EYesOrNo {
  No = 0,
  YES = 1,
}

export enum EPayType {
  /** 全款 */
  FULL = "full",
  /** 貸款 */
  LOANS = "loans",
}

/** 场景类型 */
export enum ESenceType {
  NEWCAR = "8",
  /** 快捷登录 */
  QUICK = "6",
}

/** 类型 */
export enum ERegionsType {
  /** 业代 */
  AGENT = "agent",
  /** 展间 */
  SHOWROOM = "showRoom",
  /** 业代优惠 */
  AGENTDISCOUNT = "agentDiscount",
  /** 询价 */
  INQUIRY = "inquiry",
  /** 全部 */
  ALL = "all",
}

/** 厂牌选择类型 */
export enum EBrandSelectType {
  /**  通用 */
  BASE = "base",
  /** 雷达图 */
  EVALCOMPARE = "evalCompare",
  /** 经销商 */
  DEALER = "dealer",
  /** 车友评价 */
  COMMENT = "comment",
  /** 展间 */
  SHOWROOM = "showRoom",
  /** 询价 */
  INQUIRY = "inquiry",
  INQUIRY_KIND = "inquiryKind",

  /** 业代优惠 */
  AGENTDISCOUNT = "agentDiscount",
  /** 业代 */
  AGENT = "agent",
  /** 超级测试 */
  SUPERTEST = "superTest",
  /** 电动车 */
  EV = "ev",
  /** 影音车款 */
  MOVIE = "movie",
}

export enum EBaseMenuType {
  /** 业代中心 */
  AGENT_CENTER = "agentCenter",
  /** 业代排行榜 */
  AGENT_LEADER_BOARD = "agentLeaderboard",
  /** 線上買車 */
  ONLINE_BUY_CAR = "onlineBuyCar",
  /** 买车故事 */
  SALE_STORY = "saleStory",
  /** 询价评价 */
  INQUIRY_COMMENT = "inquiryComment",
  /** 業代優惠 */
  AGENT_DISCOUNT = "agentDiscount",
  /** 業代競價 */
  AGENT_BIDDING = "agentBidding",
  /** 抢购趴抽奖券 */
  BUYING_PARTY_INQUIRY = "buyingPartyInquiry",
  /** 抢购趴中奖名单 */
  BUYING_PARTY_WINNER = "buyingPartyWinner",
  /** 优惠券 */
  BIDDING_COUPON = "biddingCoupon",
  /** 抢先获客储值 */
  BIDDING_RECHARGE = "biddingRecharge",
  /** 购车菜单 */
  BUY_CAR_MENU = "buyCarMenu",

  /** 成交詢價 */
  CURRENT = "currentCar",
}

export enum ESort {
  /** 升序排序 小到大 */
  ASC = "asc",
  /** 降序排序 大到小 */
  DESC = "desc",
}
export enum EMenuVoteType {
  /** 賺了 */
  EARN = "earn",
  /** 虧了 */
  EQUITABLE = "equitable",
  /** 合理 */
  DEFICIT = "’deficit",
}

export enum EHistoryRecordType {
  /** 新闻 */
  NEWS = "news",
  /** 试车 */
  TRIAL = "trial",
  /** 影音 */
  MOVIE = "movie",
  /** 评价 */
  RATING = "rating",
  /** 车款 */
  KIND = "kind",
  /** 购车菜单 */
  MENU = "menu",
  /** 车型 */
  MODEL = "model",
}

export enum ECommentType {
  /** 新聞 */
  NEWS = "1",
  /** 試車 */
  TEST_DRIVE = "2",
  /** 成交菜單 */
  MENU = "10",
}

export enum EBuyCarMenuRelatedType {
  /** 新聞 */
  NEWS = "1",
  /** 試車 */
  TEST_DRIVE = "2",
  /** 影音 */
  VIDEO = "3",
}

/** 通用状态 */
export enum EActiveStatus {
  /** 已结束 */
  END = 0,
  /** 进行中 */
  PENDING = 1,
}
/** 开奖状态 */
export enum EActivityShowStatus {
  /** 未开始 */
  NO = 0,
  /** 等待 */
  PENDING = 1,
  /** 已完结 */
  END = 2,
}
/** 中奖状态 */
export enum ELotteryStatus {
  /** 未参与 */
  NOT_JOIN = -2,
  /** 未中奖 */
  NOT_HIT = -1,
  /** 待开奖 */
  PENDING = 0,
  /** 已中奖 */
  HIT = 1,
}
